import React, {useState, useEffect} from "react";
import { Container, Row, Col } from "react-bootstrap";
import siteUtils from "../utils/siteUtils";
import AddAttachmentPopUp from "./AddAttachmentPopUp";
import { Loading } from './Loading';
import ServiceCalls from "../utils/serviceCalls";
import RequestUtils from "../utils/requestUtils";
import DeleteAttachmentPopUp from "./DeleteAttachmentPopUp";  
import "../styles/Vendor.css";

const WorklistAttachments = (props) => {

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {  
    if (props.Request) {  
      setIsLoading(false);  
    }  
  }, [props.Request]);  

  const loadTable = () => {
      props.refresh(props.currentCompanyId);
    setIsLoading(true);
  }

  const downloadFile = (attachment) => {    
    const attachInfo = {      
      FileName: attachment.fileName,      
      StorageURL: attachment.storageUrl      
    };   
    
    ServiceCalls.downloadAttachment(attachInfo)    
      .then((response) => {    
        const url = window.URL.createObjectURL(response);    
        const link = document.createElement('a');    
        link.href = url;    
        link.setAttribute('download', attachInfo.FileName);    
        document.body.appendChild(link);    
        link.click();    
 
      })    
      .catch((error) => {    
        console.log("Failed to download file");    
      });    
  }  
   
  const buildTable = () => {
    let showTrashButton;
    if (props.Request && props.Request.bankRequest) {
      showTrashButton = RequestUtils.checkDeleteAttachmentsPerms(props.Request.bankRequest.requestStatusId, props.currentUser, props.currentCompanyId);
    }
    if (props.Request.requestAttachments?.length > 0) {
      return (
        <table className="attachment-table">
          <thead>
            <tr>
              <th className="column-header">Date</th>
              <th className="column-header">Attached By</th>
              <th className="column-header">Type</th>
              <th className="column-header">File Name</th>
            </tr>
          </thead>
          
          <tbody>
            {props.Request.requestAttachments.map((attachment, index) => (
              <tr key={index}>
                <td>{siteUtils.formatDate(attachment.createdDt)}</td>
                <td>
                  {attachment.submitterContact.lastName},{" "}
                  {attachment.submitterContact.firstName}
                </td>
                <td>{attachment.attachmentTypeId === 1 ? "Bank Letter" : "Voided Check"}</td>
                <td className="attachment-table-buttons" >  
                        <button className="buttonLink" onClick={(e) => {e.preventDefault(); downloadFile(attachment);}}>{attachment.fileName}</button>    
                   <DeleteAttachmentPopUp attachment={attachment} loadTable={loadTable} showButton={showTrashButton}/>    
                </td>  

              </tr>
            ))}
          </tbody>
        </table>
      );
    }
    return (
      <Col>
        <h4>No Attachments</h4>
      </Col>
    );
  };

  const showPopupButton = () => {
		if (props.Request && props.Request.bankRequest) {
			return RequestUtils.checkCommentsAndAttachmentsPerms(props.Request.bankRequest.requestStatusId, props.currentUser, props.currentCompanyId);
		}
		return false;
	};


  return (
    <>
      <Container fluid>
        <Row>
          <Col md={2}>
            <h3 className="commentsHeader">Attachments</h3>
          </Col>
          <Col md={1} className="offset-md-9 pl-1">
              <AddAttachmentPopUp Request={props.Request} currentUser={props.currentUser} currentCompanyId={props.currentCompanyId} showButton={showPopupButton} loadTable={loadTable}/>
          </Col>
        </Row>
      </Container>

      <Container
        className="vendorArea border-left-dark shadow borderCurve"
        fluid>
          {isLoading ? <Loading/> :  buildTable()}
      </Container>
    </>
  );
};
export default WorklistAttachments;
